import styled from 'styled-components';

export const FrodPageContainer = styled.div`
  // padding-left: 159px;
  // padding-top: 105px;
`;
